import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./RegisterB2BStyle.scss";
import RegisterB2BForm from "./RegisterB2BForm";
import { MAIN_APP } from "../../routes";

const RegisterB2BPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const offerId = searchParams.get("offerId");
  const id = searchParams.get("id");

  const handleBackToShop = () => {
    if (offerId) {
      navigate(`${MAIN_APP}?offerId=${offerId}${id ? `&id=${id}` : ""}`);
    } else {
      navigate(MAIN_APP);
    }
  };

  return (
    <div className="register-b2b-page">
      <div className="register-b2b-page-container">
        <RegisterB2BForm onGoBack={handleBackToShop} />
      </div>
    </div>
  );
};

export default RegisterB2BPage; 